import React, { useState, ReactNode } from 'react';
import { Document, Page } from 'react-pdf';
import { ControlButton } from './ControlButton';
import { Icons } from '../icons';
import { useWindowWidth } from '@distribute/frontend/utils';

interface PDFPreviewModalProps {
  fileUrl: string;
  fileName: string;
  onClose: () => void;
  controlPanel: ReactNode;
  scale: number;
  pageNumber: number;
}

export const PdfExtendedPreview: React.FC<PDFPreviewModalProps> = ({
  fileUrl,
  fileName,
  onClose,
  controlPanel,
  scale,
  pageNumber,
}) => {
  const [error, setError] = useState<string | null>(null);

  const { windowWidth, isTabletOrMobile } = useWindowWidth();

  if (error) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-base-black/[0.75]">
        <div className="p-6 text-center bg-white rounded-lg shadow-xl">
          <p className="mb-4 text-error-500">{error}</p>
          <ControlButton
            icon={Icons.XClose}
            tooltipText="Close"
            onClick={onClose}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center overflow-hidden bg-base-black/[0.75] pt-19 pb-11">
      <div className="absolute left-0 flex items-center justify-between w-full px-6 top-4">
        <span className="text-lg text-base-white">{fileName}</span>
        <button onClick={onClose} className="text-gray-600 hover:text-gray-900">
          <ControlButton
            icon={Icons.XClose}
            tooltipText="Close preview"
            onClick={onClose}
          />
        </button>
      </div>
      <div className="relative flex justify-center w-full h-full overflow-hidden bg-white rounded-lg shadow-2xl">
        <div className="h-full overflow-auto w-170 md:w-[80vw]">
          <Document file={fileUrl} className="w-full">
            <Page
              pageNumber={pageNumber}
              scale={scale}
              width={isTabletOrMobile ? windowWidth / 1.25 : 680}
              renderTextLayer={false}
              renderAnnotationLayer={false}
              className="w-full !bg-gray-500 flex justify-center"
            />
          </Document>
        </div>
      </div>
      <div className="absolute flex items-center -translate-x-1/2 rounded-full bottom-4 left-1/2">
        {controlPanel}
      </div>
    </div>
  );
};
